import React, { useState, useEffect } from 'react';
import Modal from '.';
import moment from 'moment';
import { API_GET } from '../../helpers/api';
import LabelValue from '../LabelValue';
import Icon from '../Icon';

export default function ModalContractHistory(props) {
  const { isOpen, toggle, contract } = props;
  const [history, setHistory] = useState([]);

  useEffect(() => {
    getContractHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract]);

  const getContractHistory = async () => {
    let res = await API_GET(
      `system-parameter/contract/${contract.id}/historyOnlyStatusAndType`
    );
    setHistory(res.data);
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className='km__p--parameter-history-title'>
        Kontrat İşlem Geçmişi
        <div>
          <Icon name='x' size='16' onClick={toggle} />
        </div>
      </div>
      <div className='km__p--parameter-history-wrapper'>
        {history.map((item, index) => {
          return (
            <div className='km__p--parameter-history-body' key={index}>
              <div>
                <LabelValue label='Kontrat Adı' value={item.contractName} />
                <LabelValue
                  label='İşlem Değeri'
                  value={
                    item.status === 'ACTIVE' ? 'Aktivasyon' : 'Deaktivasyon'
                  }
                />
              </div>
              <div>
                <LabelValue
                  label='İşlem Tarihi'
                  value={moment(item.lastModifiedDate).format(
                    'DD.MM.YYYY HH:mm:ss'
                  )}
                />
                <LabelValue label='Açıklama' value={item.description} />
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
}
